module.exports = __webpack_public_path__ + "img/cave81.311da45b.jpg";